export enum USState {
    AL = "Alabama",
    AK = "Alaska",
    AZ = "Arizona",
    AR = "Arkansas",
    CA = "California",
    CO = "Colorado",
    CT = "Connecticut",
    DE = "Delaware",
    FL = "Florida",
    GA = "Georgia",
    HI = "Hawaii",
    ID = "Idaho",
    IL = "Illinois",
    IN = "Indiana",
    IA = "Iowa",
    KS = "Kansas",
    KY = "Kentucky",
    LA = "Louisiana",
    ME = "Maine",
    MD = "Maryland",
    MA = "Massachusetts",
    MI = "Michigan",
    MN = "Minnesota",
    MS = "Mississippi",
    MO = "Missouri",
    MT = "Montana",
    NE = "Nebraska",
    NV = "Nevada",
    NH = "New Hampshire",
    NJ = "New Jersey",
    NM = "New Mexico",
    NY = "New York",
    NC = "North Carolina",
    ND = "North Dakota",
    OH = "Ohio",
    OK = "Oklahoma",
    OR = "Oregon",
    PA = "Pennsylvania",
    RI = "Rhode Island",
    SC = "South Carolina",
    SD = "South Dakota",
    TN = "Tennessee",
    TX = "Texas",
    UT = "Utah",
    VT = "Vermont",
    VA = "Virginia",
    WA = "Washington",
    WV = "West Virginia",
    WI = "Wisconsin",
    WY = "Wyoming"
}

// Create an array of state options for dropdowns
export const US_STATES_OPTIONS = Object.entries(USState).map(([code, name]) => ({
    value: name, // Use full name as value for API compatibility
    label: `${name} (${code})`, // Display name with code
    code: code // Keep code for reference
}));

// Helper function to get state code from state name
export const getStateCodeFromName = (stateName: string): string | undefined => {
    const entry = Object.entries(USState).find(([, name]) => name === stateName);
    return entry ? entry[0] : undefined;
};

// Helper function to get state name from state code
export const getStateNameFromCode = (stateCode: string): string | undefined => {
    return USState[stateCode as keyof typeof USState];
};